// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"641":"bb7af431","1029":"e4f2bcf4","1573":"b1e19e8b","2448":"bf83eb5e","2835":"2e3d5017","5089":"2e98f0ee","5653":"155c819d","8502":"022e668d","9832":"60478c56"}[chunkId] + ".chunk.css";
};